export const PROFESSION_LABELS = {
  ALL: "All",
  INFORMATIK: "Informatik",
  MEDIAMATIK: "Mediamatik",
  KV: "KV",
  KUNDENDIALOG: "Kundendialog",
  DETAILHANDEL: "Detailhandel",
  UNKNOWN: "Unknown",
};

export const PROFESSION_ORDER = [
  "INFORMATIK",
  "MEDIAMATIK",
  "KV",
  "KUNDENDIALOG",
  "DETAILHANDEL",
  "UNKNOWN",
];

// CHECKED is the single positive outcome; FINALIZED is the retired legacy value.
export const isCheckedStatus = (status) =>
  status === "CHECKED" || status === "FINALIZED";

export const statusBadgeClasses = (status) => {
  if (isCheckedStatus(status)) return "bg-green-100 text-green-800 border border-green-200";
  if (status === "REJECTED") return "bg-red-100 text-red-700 border border-red-200";
  return "bg-gray-100 text-gray-700 border border-gray-200";
};

export const confirmationBadgeClasses = (status) => {
  if (status === "CONFIRMED") return "bg-blue-100 text-blue-700 border border-blue-200";
  return "bg-red-100 text-red-700 border border-red-200";
};

export const fmtDate = (value) => {
  if (!value) return "-";
  return new Date(value).toLocaleDateString("de-CH");
};

export const fmtDateTime = (value) => {
  if (!value) return "-";
  return new Date(value).toLocaleString("de-CH");
};

export const normalizeRole = (role) => {
  const raw = typeof role === "string" ? role : role?.name || role?.authority;
  if (!raw || typeof raw !== "string") return "";
  return raw.toUpperCase().replace(/^ROLE_/, "");
};
